import * as React from 'react'

const SvgChemistryIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4612_42679)">
      <path
        d="M15.8337 0H4.16699V1.66667H5.83366V15.8333C5.83366 16.9384 6.27265 17.9982 7.05405 18.7796C7.83545 19.561 8.89526 20 10.0003 20C11.1054 20 12.1652 19.561 12.9466 18.7796C13.728 17.9982 14.167 16.9384 14.167 15.8333V1.66667H15.8337V0ZM10.0003 18.3333C9.33728 18.3333 8.7014 18.0699 8.23256 17.6011C7.76372 17.1323 7.50033 16.4964 7.50033 15.8333V7.5H12.5003V15.8333C12.5003 16.4964 12.2369 17.1323 11.7681 17.6011C11.2993 18.0699 10.6634 18.3333 10.0003 18.3333ZM12.5003 5.83333H7.50033V1.66667H12.5003V5.83333Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4612_42679">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgChemistryIcon
